import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import { Alert, CircularProgress } from '@mui/material'
import { currentPageUrl, loginUrl } from 'utils/loginRedirect'
const AdminAccess = ({ children }) => {
  const user = useSelector(state => state.user)
  const location = useLocation()
  if (user.isFetching) return <CircularProgress aria-label="Loading account" />
  if (!user.details) return <Navigate to={loginUrl(currentPageUrl(location))} replace />
  if (!user.details.userRoles?.includes('ROLE_ADMIN')) return <Alert severity="error">Administrator access is required.</Alert>
  return children
}

export default AdminAccess
